import React from 'react';
import { Link } from '@framework/router/Next/Link';
import SharedCustomers from '@framework/ui/Pages/Landing/Sections/Customers';
import Button from '@dealroadshow/uikit-button';
import Section from '@framework/ui/Pages/Landing/Sections/Section';
import SectionContainer from '@framework/ui/Pages/Landing/Sections/SectionContainer';
import SectionHeader from '@framework/ui/Pages/Landing/Sections/SectionHeader';
import URL from '@evercall/url/urlConstants';
import customers from './constants';
import styles from './customers.module.scss';
import { CUSTOMERS_SECTION_ID } from '@/evercall/ui/components/Features/Customers/constants';

const Customers = () => (
  <Section padding="top" dataTest="customersSection">
    <SectionContainer size="large">
      <SectionHeader
        title="Experience a new standard for moderated events."
        description="Hundreds of the world’s leading investment banks and corporations trust Evercall to empower their most critical conversations."
        className={ styles.headerWrapper }
        maxWidth={ 800 }
      />
      <SharedCustomers
        customers={ customers }
        showMoreButton={ (buttonProps) => (
          <Link
            to={ `${ URL.FEATURES }#${ CUSTOMERS_SECTION_ID }` }
            dataTest="exploreOurCustomers"
          >
            <Button
              { ...buttonProps }
              title="Explore Our Customers"
              dataTest="exploreOurCustomersButton"
            />
          </Link>
        ) }
      />
    </SectionContainer>
  </Section>
);

export default Customers;
